// app/composables/countries.ts

import type { CountryDTO } from "~/src/country/infrastructure/DTO/CountryDTO";

interface useCountries {
  getCountries: () => Promise<CountryDTO[] | undefined>;
  getCountry: (countryId: number) => Promise<CountryDTO | undefined>;
}

export const useCountries = (): useCountries => {
  return {
    getCountries,
    getCountry,
  };
};

async function getCountry(countryId: number): Promise<CountryDTO | undefined> {
  try {
    const path = `/api/v1/countries/${countryId}`;
    const country = await $fetch<CountryDTO>(path);
    if (country) {
      return country;
    } else {
      console.error("Fetched country is null");
    }
  } catch (e) {
    console.error("Error fetching country:", e);
  }
}

async function getCountries(): Promise<CountryDTO[] | undefined> {
  const path = `/api/v1/countries`;

  try {
    return await $fetch<CountryDTO[]>(path);
  } catch (e) {
    console.error("Error fetching countries:", e);
  }
}
